/**
 * @function formatBytes Formats a number of bytes into a string with a suffix, such as 'KB', 'MB', etc.
 * @param {number} bytes The number of bytes
 * @param {number} decimals The number of decimal values to represent (default: 2)
 */
export function formatBytesToString(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k: number = 1024;
  const dm: number = decimals < 0 ? 0 : decimals;
  const sizes: Array<string> = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i: number = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
